import gql from 'graphql-tag';

export default gql`
mutation ($id: String!) {
    deleteReport (input: { id: $id }) {
        __typename
        id
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Reports/DeleteMutation.js